import { loadLogger } from 'lib/dynamicModules';

export const getRouterLogger = async () => {
  const logger = await loadLogger();

  const routerLogger = logger.child({ event: { tag: 'navigation' } });

  return routerLogger;
};
